var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dcb9c610bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.90625 1.101562 L 28.035156 1.101562 L 28.035156 27.957031 L 1.90625 27.957031 Z M 1.90625 1.101562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcb9c610bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M 9.171875 3.375 C 6.425781 3.375 4.195312 5.605469 4.195312 8.351562 L 4.195312 20.9375 C 4.195312 23.679688 6.425781 25.914062 9.171875 25.914062 L 21.082031 25.914062 C 23.824219 25.914062 26.058594 23.679688 26.058594 20.9375 L 26.058594 8.351562 C 26.058594 5.605469 23.824219 3.375 21.082031 3.375 Z M 21.082031 28.183594 L 9.171875 28.183594 C 5.175781 28.183594 1.921875 24.933594 1.921875 20.9375 L 1.921875 8.351562 C 1.921875 4.355469 5.175781 1.101562 9.171875 1.101562 L 21.082031 1.101562 C 25.078125 1.101562 28.328125 4.355469 28.328125 8.351562 L 28.328125 20.9375 C 28.328125 24.933594 25.078125 28.183594 21.082031 28.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M 15.125 10.335938 C 12.75 10.335938 10.820312 12.269531 10.820312 14.644531 C 10.820312 17.019531 12.75 18.949219 15.125 18.949219 C 17.5 18.949219 19.433594 17.019531 19.433594 14.644531 C 19.433594 12.269531 17.5 10.335938 15.125 10.335938 Z M 15.125 21.222656 C 11.5 21.222656 8.546875 18.269531 8.546875 14.644531 C 8.546875 11.015625 11.5 8.066406 15.125 8.066406 C 18.753906 8.066406 21.703125 11.015625 21.703125 14.644531 C 21.703125 18.269531 18.753906 21.222656 15.125 21.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M 23.34375 7.253906 C 23.34375 8.023438 22.71875 8.648438 21.949219 8.648438 C 21.183594 8.648438 20.558594 8.023438 20.558594 7.253906 C 20.558594 6.484375 21.183594 5.863281 21.949219 5.863281 C 22.71875 5.863281 23.34375 6.484375 23.34375 7.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ba85a43bdf08395506bd42bb7c8db46c.svg";
export { ForwardRef as ReactComponent };